export default {"wrapper":"Ln7GS","mainContent":"Rqt4E","mainTitle":"_4LcG9","termsItem":"xWlbm","name":"yUUjy","group":"_6ZzVB"};